import { showWarningMessage } from '../../../_component/MessageSnack';
import axiosInstance from '../../../_config/AxiosInstance';
import config from '../../../_config/config';
import { organisationConstants } from '../../constant';

export const create_organisation_action = (data) => async (dispatch) => {
  dispatch({
    type: organisationConstants.CREATE_ORGANISATION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(config.organisation.organisation, data);
    if (response.status) {
      let data = response.data;
      dispatch({
        type: organisationConstants.CREATE_ORGANISATION_SUCCESS,
        payload: data.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: organisationConstants.CREATE_ORGANISATION_FAILURE,
      payload: e?.error,
    });
    showWarningMessage(e.error || e.message);
  }
};

export const update_organisation_action = (id, data) => async (dispatch) => {
  dispatch({
    type: organisationConstants.UPDATE_ORGANISATION_REQUEST,
  });
  try {
    const response = await axiosInstance.put(`${config.organisation.organisation}/${id}`, data);
    if (response.status) {
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: organisationConstants.UPDATE_ORGANISATION_FAILURE,
      payload: e?.error,
    });
    showWarningMessage(e.error || e.message);
  }
};

export const create_organisation_user_action = (data) => async (dispatch) => {
  dispatch({
    type: organisationConstants.CREATE_ORGANISATION_USER_REQUEST,
  });
  try {
    const response = await axiosInstance.post(config.organisation.organisationUser, data);
    if (response.status) {
      let data = response.data;
      dispatch({
        type: organisationConstants.CREATE_ORGANISATION_USER_SUCCESS,
        payload: data.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: organisationConstants.CREATE_ORGANISATION_USER_FAILURE,
      payload: e?.error,
    });
    // showWarningMessage(e.error || e.message);
  }
};

export const update_organisation_user_action = (id, data) => async (dispatch) => {
  dispatch({
    type: organisationConstants.UPDATE_ORGANISATION_USER_REQUEST,
  });
  try {
    const response = await axiosInstance.put(`${config.organisation.organisationUser}/${id}`, data);
    if (response.status) {
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: organisationConstants.UPDATE_ORGANISATION_USER_FAILURE,
      payload: e?.error,
    });
    showWarningMessage(e.error || e.message);
  }
};

export const get_organisation_users_action = () => async (dispatch) => {
  dispatch({
    type: organisationConstants.GET_ORGANISATION_USERS_REQUEST,
  });
  try {
    const response = await axiosInstance.get(config.organisation.getOrganisationUsers);
    if (response.status) {
      let data = response.data;
      dispatch({
        type: organisationConstants.GET_ORGANISATION_USERS_SUCCESS,
        payload: data.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: organisationConstants.GET_ORGANISATION_USERS_FAILURE,
      payload: e?.error,
    });
    showWarningMessage(e.error || e.message);
  }
};

export const delete_organisation_user_action = (id) => async (dispatch) => {
  dispatch({
    type: organisationConstants.DELETE_ORGANISATION_USER_REQUEST,
  });

  try {
    const response = await axiosInstance.delete(`${config.organisation.organisationUser}/${id}`);
    if (response.status) {
      dispatch({
        type: organisationConstants.DELETE_ORGANISATION_USER_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: organisationConstants.DELETE_ORGANISATION_USER_FAILURE,
      payload: e?.error,
    });
  }
};

export const get_organisation_action = (id) => async (dispatch) => {
  dispatch({
    type: organisationConstants.GET_ORGANISATION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(`${config.organisation.organisation}/${id}`);
    if (response.status) {
      let data = response.data;
      dispatch({
        type: organisationConstants.GET_ORGANISATION_SUCCESS,
        payload: data.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: organisationConstants.GET_ORGANISATION_FAILURE,
      payload: e?.error,
    });
    showWarningMessage(e.error || e.message);
  }
};

export const get_my_organisation_action = () => async (dispatch) => {
  dispatch({
    type: organisationConstants.GET_MY_ORGANISATION_REQUEST,
  });

  try {
    const response = await axiosInstance.get(config.organisation.organisation);
    if (response.status) {
      let data = response.data;
      dispatch({
        type: organisationConstants.GET_MY_ORGANISATION_SUCCESS,
        payload: data.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: organisationConstants.GET_MY_ORGANISATION_FAILURE,
      payload: e?.error,
    });
  }
};
